import { type UploadFile } from 'antd'

export const formatterUploadList = (fileUrl: string) => {
  const defaultFileList: UploadFile[] = []

  if (fileUrl) {
    defaultFileList.push({
      uid: crypto.randomUUID(),
      name: crypto.randomUUID(),
      status: 'done',
      url: fileUrl,
    })
  }

  return defaultFileList
}
